/**
 * Creates Node to display rating with 5 stars.
 * Contains some functions in <i>node.ratings</i>.
 * You can change <i>color</i> and <i>font-size</i> with CSS.
 * @param {Object} options
 * Options are optional.
 * <ul>
 * <li><i>value</i>: Initial value. Float between 0 and 5</li>
 * <li><i>input</i>: Possible to enable user input. Values are strings. <i>int</i> or <i>float</i>
 * Keep this undefined to use read-only</li>
 * </ul>
 * @returns {Element}
 */
function Ratings(options) {
  "use strict";

  //force new statement
  if (!(this instanceof Ratings)) return new Ratings(options);

  if (typeof options === "undefined") options = {};

  if (options.value === undefined) options.value = 1;

  if (options.nStars === undefined) options.nStars = 5;
  else options.nStars = Math.max(options.nStars, 1);

  //generate wrapper node
  var node = document.createElement("div");
  node.classList.add("rating-stars");
  node.style.width = options.nStars + "em";

  //inside html
  var html = '<div class="bg">'; //gray stars for background

  for (var i = 0; i < options.nStars; i++)
    html += '<i class="material-icons">star_rate</i>';
  html += "</div>" + '<div class="value">'; //gold stars for value
  for (var i = 0; i < options.nStars; i++)
    html += '<i class="material-icons" data-n=' + (i - 1) + ">star_rate</i>";
  html += "</div>";

  //put html to node
  node.insertAdjacentHTML("afterbegin", html);

  //add functions
  node.rating = {
    _value: 0,
    /**
     * Applies value to UI and var.
     * @param {number} value
     * Float between 0 and 5
     * @returns {undefined}
     */
    setValue: function (value) {
      var that = node;

      if (options.input === "int")
        // +0.5 prevent select 0 stars and select prev star
        value = Math.round(value + 0.5);

      value = Math.max(value, 0);
      value = Math.min(value, options.nStars);

      //on int, minimal input value is 1
      //only possible if user drag to negative position
      if (options.input === "int" && value === 0) value = 1;

      var percent = (100 / options.nStars) * value;

      //set width value on div.value
      that.children[1].style.width = percent + "%";

      //store to avoid calculation from stylings
      this._value = value;
    },
    /**
     * Returns current value.
     * @returns {Number}
     * Float between 0 and <i>options.nStars</i>
     */
    getValue: function () {
      return this._value;
    },
  };

  //set default value
  node.rating.setValue(options.value);

  //enable user input
  switch (options.input) {
    case "int":
    case "float":
      //cursor: pointer
      node.classList.add("rating-stars--input");
      //event listener
      node.addEventListener("mouseup", mouseHandler);
      node.addEventListener("mousemove", mouseHandler);
      node.addEventListener("touchend", mouseHandler);
      node.addEventListener("touchmove", mouseHandler);
  }

  /**
   * Calculate value from event for UI and set it.
   * @param {Event} event
   * @returns {undefined}
   */
  function mouseHandler(event) {
    //only affect if mouse button is down
    if (event.type === "mousemove" && event.buttons === 0) return;

    var width = this.getBoundingClientRect().width;

    //touch and mouse events are different to getting cursor position
    var xPosition = 0;
    switch (event.type) {
      case "mouseup":
      case "mousemove":
        xPosition = event.layerX;
        break;
      case "touchend":
      case "touchmove":
        xPosition =
          event.changedTouches[0].pageX -
          parseInt(this.getBoundingClientRect().left, 10);
        break;
    }

    var percent = parseInt((100 / width) * xPosition, 10);
    var value = percent / (100 / options.nStars);

    node.rating.setValue(value);
  }

  return node;
}
